import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../assets/css/GridModal.css';
import Zoomproduct from '../Component/Zoomproduct';
import toast, { Toaster } from 'react-hot-toast';

const ModalBoxPopup = ({ Modal, detailModalShow, handleDetailModalClose, Button, currentImage }) => {
  const [quantity, setQuantity] = useState('');
  const [isCustomInput, setIsCustomInput] = useState(false); // State to toggle custom input
  const [zoomModalShow, setZoomModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const notify = () => toast.success('Successfully toasted!')

  const handleSelectChange = (e) => {
    const value = e.target.value;
    if (value === "10+") {
      setIsCustomInput(true); // Show custom input when "10+" is selected
      setQuantity(''); // Reset quantity to empty string for custom input
    } else {
      setQuantity(value);
      setIsCustomInput(false); // Hide custom input and show dropdown for other values
    }
  };

  const handleCustomInputChange = (e) => {
    const value = e.target.value;
    // Allow only digits in the input
    if (/^\d*$/.test(value)) {
      setQuantity(value); // Set quantity if the value is a valid number
    }
  };

  const handleZoomClick = () => {
    setZoomModalShow(true);
  };

  const handleZoomClose = () => {
    setZoomModalShow(false);
  };

  // Simulate data fetching
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000); // 3 seconds delay
  }, []);

  return (
    <>
      <Modal show={detailModalShow} onHide={handleDetailModalClose} fullscreen centered>
        <Modal.Body className="text-center">
          <Button
            variant="light"
            onClick={handleDetailModalClose}
            className="position-absolute top-0 end-0 close-btns"
            style={{ zIndex: 1050 }}
          >
            <i className="bi bi-x-lg"></i>
          </Button>
          <div className="box-Content-Ration">
            <div className="row">
              <div className="col-md-4">
                <div className="image-gallery position-relative">
                  {isLoading ? (
                    <Skeleton height={400} width="100%" />
                  ) : currentImage ? (
                    <img
                      src={currentImage}
                      alt="Detailed View"
                      style={{ width: '100%', height: 'auto' }}
                    />
                  ) : (
                    <p>No detailed data available.</p>
                  )}
                  <span
                    className="zoomicon"
                    onClick={handleZoomClick}
                    style={{
                      cursor: 'pointer',
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                    }}
                  >
                    <i className="bi bi-zoom-in"></i>
                  </span>
                </div>
                <h3 className="text-xl text-gray-500">
                  {isLoading ? <Skeleton width={150} /> : 'AFROZ 6735B RIX53'}
                </h3>
              </div>
              <div className="col-md-8">
                <div className="text-left">
                  <h4 className="text-gray-500 pt-2 font-normal">
                    {isLoading ? <Skeleton width={100} /> : 'SPECIFICATION'}
                  </h4>
                  <p className="text-gray-600">
                    {isLoading ? <Skeleton count={3} /> : 'Pile: 100% Polyester, Pile Height 9 ± 1mm, Pile Weight sqm 980 grm ± 100 grm, Total Weight sqm 1800 grm ± 100 grm, Backing Cotton'}
                  </p>
                  <div className="table-responsive table-cont table-box-content">
                    <table className="table table-sm table-striped mb-0">
                      <thead className="text-center">
                        <tr>
                          <th className="table-header">Size</th>
                          <th className="table-header">Barcode</th>
                          <th className="table-header">Shape</th>
                          <th className="table-header">Stock</th>
                          <th className="table-header">Ord. Qty</th>
                          <th className="table-header">MRP (₹)</th>
                          <th className="table-header">Cart</th>
                          <th className="table-header">Wishlist</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="align-middle">
                            {isLoading ? <Skeleton width={60} /> : '60X150'}
                          </td>
                          <td className="align-middle">
                            {isLoading ? <Skeleton width={120} /> : '8907831253440'}
                          </td>
                          <td className="align-middle">
                            {isLoading ? <Skeleton width={80} /> : 'Rectangle'}
                          </td>
                          <td className="align-middle text-center">
                            {isLoading ? <Skeleton width={40} /> : '53'}
                          </td>
                          <td className="align-middle text-center">
                            {isLoading ? (
                              <Skeleton width={60} />
                            ) : (
                              <>
                                {/* Dropdown will be hidden if 10+ is selected */}
                                {!isCustomInput && (
                                  <select
                                    className="form-control form-control-sm select-List text-center"
                                    value={quantity}
                                    onChange={handleSelectChange}
                                  >
                                    <option value="">0</option>
                                    {[...Array(10)].map((_, index) => (
                                      <option key={index} value={index + 1}>
                                        {index + 1}
                                      </option>
                                    ))}
                                    <option value="10+">10+</option>
                                  </select>
                                )}
                                
                                {/* Custom input field shown when "10+" is selected */}
                                {isCustomInput && (
                                  <input
                                    type="number"
                                    value={quantity}
                                    onChange={handleCustomInputChange}
                                    className="form-control form-control-sm mt-2"
                                    placeholder="0"
                                    width={30}
                                    style={{ width: "64px", margin: "0 auto"}}
                                  />
                                )}
                              </>
                            )}
                          </td>
                          <td className="align-middle">
                            {isLoading ? <Skeleton width={80} /> : '3900.00'}
                          </td>
                          <td className="align-middle text-center">
                            <div className="customer-selected-cart">
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary addtocart"
                                title="Add to Cart"
                                onClick={notify}
                               >
                                {/* <i className="fa fa-spinner fa-spin" id="spinner_31185"></i> */}
                                <i className="bi bi-cart-plus"></i>
                              </button>
                              <Toaster position='top-right' reverseOrder={false} /> 
                            </div>
                          </td>
                          <td className="align-middle text-center">
                            <div className="btn btn-outline-secondary WishListbtn">
                              <button type="button" title="Add to Wishlist" style={{ border:"none"}}>
                                <i className="bi bi-heart"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Zoom Modal */}
      <Zoomproduct
        show={zoomModalShow}
        onHide={handleZoomClose}
        currentImage={currentImage}
      />
    </>
  );
};

export default ModalBoxPopup;
